import { http, fetchCsrfToken } from '@/services/http.jsx';
import { env } from '@/shared/config/Environment.jsx';

// Returns the current authenticated user (or throws on non-401 errors)
export async function fetchUser() {
  try {
    const res = await http.get('/api/user');
    // Return the user data directly from the response
    return res?.data ?? null;
  } catch (error) {
    // Handle 401 gracefully - user not authenticated
    if (error.response?.status === 401) {
      return null;
    }
    // Re-throw other errors
    throw error;
  }
}

export async function login(payload) {
  await fetchCsrfToken();
  const body = {
    // Backend expects 'identifier' (email or username); fallback to email
    identifier: payload?.identifier || payload?.email,
    password: payload?.password,
    remember: !!payload?.remember,
  };
  // POST /login is a web route at the app root, not under /api
  const base = env.api.baseUrl || '';
  const root = base.endsWith('/api') ? base.slice(0, -4) : base.replace(/\/api$/, '');
  return http.post('/login', body, { baseURL: root });
}

export async function logout() {
  await fetchCsrfToken();
  // POST /logout is a web route at the app root, not under /api
  const base = env.api.baseUrl || '';
  const root = base.endsWith('/api') ? base.slice(0, -4) : base.replace(/\/api$/, '');
  return http.post('/logout', {}, { baseURL: root });
}

// Account management functions
export async function updateFullName(data) {
  await fetchCsrfToken();
  return http.patch('/auth/account/full-name', data);
}

export async function updateCountry(data) {
  await fetchCsrfToken();
  return http.patch('/auth/account/country', data);
}

export async function updatePassword(data) {
  await fetchCsrfToken();
  return http.patch('/auth/account/change-password', data);
}

export async function requestEmailChange(data) {
  await fetchCsrfToken();
  return http.post('/auth/account/request-email-change', data);
}

export async function cancelEmailChange() {
  await fetchCsrfToken();
  return http.post('/auth/account/cancel-email-change');
}

export async function verifyEmailChange(data) {
  await fetchCsrfToken();
  return http.post('/auth/verify-email-change', data);
}

export async function getAccountStatus() {
  return http.get('/auth/account/status');
}

// Alias for useAuth hook compatibility
export const me = fetchUser;
